import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import * as policiesActions from "../../store/actions/policies";
import styles from "./ViewPolicies.module.css";
import Input from "../shared/ui/input/Input";
import PoliciesList from "./policies-list/PoliciesList";
import NoData from "../shared/ui/no-data/NoData";
import { baseTitle } from "../../constants/messages";
import { PERSONAL } from "../../constants/keys";

function ViewPolicies() {
  const dispatch = useDispatch();
  let agent = useSelector((state) => state.user.agentInfo);
  let authenticated = useSelector((state) => state.user.agentAuthenticated);
  let isLoading = useSelector((state) => state.app.isLoading);
  let policies = [];
  let policyType = useSelector((state) => state.app.policyType);
  let personalPolicies = useSelector(
    (state) => state.policies.personalPolicies
  );
  let commercialPolicies = useSelector(
    (state) => state.policies.commercialPolicies
  );
  const [searchPolicies, setSearchPolicies] = useState([]);

  const handleSearch = (event) => {
    if (event.target.value === "") {
      setSearchPolicies(policies);
    } else {
      if (event.target.id === "policyNumber") {
        setSearchPolicies(
          policies.filter((i) => i.PolicyNumber.startsWith(event.target.value))
        );
      } else if (event.target.id === "insuredName") {
        setSearchPolicies(
          policies.filter((i) => i.InsuredName.includes(event.target.value))
        );
      }
    }
  };

  if (policyType.active === PERSONAL) {
    policies = personalPolicies;
  } else {
    policies = commercialPolicies;
  }

  useEffect(() => {
    if (authenticated) {
      dispatch(
        policiesActions.getAgentPolicies(
          agent.agentCode,
          agent.parentCode,
          agent.userClass
        )
      );
    }
  }, [dispatch, agent, authenticated]);

  useEffect(() => {
    document.title = baseTitle + " - View Policies";
  });

  return (
    <div className={styles.container}>
      <div className="formRow">
        <h1 className={styles.header}>Your Policies</h1>
        <span className={styles.active}>
          Select policy to begin claim submission process
        </span>
      </div>
      {policies.length > 0 && !isLoading ? (
        <>
          <div className={styles.searchRow}>
            <Input width="50%">
              <input
                id="policyNumber"
                placeholder="Search Policy Number"
                onChange={(e) => handleSearch(e)}
                aria-label="Search Policy Number"
              />
            </Input>
            <Input width="50%">
              <input
                id="insuredName"
                placeholder="Search Insured Name"
                onChange={(e) => handleSearch(e)}
                aria-label="Search Insured Name"
              />
            </Input>
          </div>
          {!isLoading && (
            <PoliciesList
              policies={searchPolicies.length > 0 ? searchPolicies : policies}
            />
          )}
        </>
      ) : (
        <NoData message="NO POLICIES" />
      )}
    </div>
  );
}

export default ViewPolicies;
